import React from 'react';

import { useFormikContext } from 'formik';

import Input from 'components/Input';
import CurrencyInput from 'containers/CurrencyInput';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Header, Body, StyledField as Field } from './styles';

export enum Type {
  National = 'national',
  International = 'international',
}

interface Props {
  type: Type;
}

const AutoRestriction = ({ type }: Props) => {
  const { t } = useStoreTranslation();
  const formik = useFormikContext();

  return (
    <Container>
      <Header>
        <Header.Title>
          {t(
            type === Type.National ? 'rule.restriction.auto.titleNational' : 'rule.restriction.auto.titleInternational',
          )}
        </Header.Title>
      </Header>
      <Body>
        <Field name={`${type}VehicleAnticipation`} label={t('rule.restriction.anticipation')}>
          <Input
            suffix={t('rule.restriction.anticipationSuffix')}
            darkPlaceholder
            placeholder={t('rule.restriction.withoutRestriction')}
            onBlur={(e) => {
              if (e.currentTarget.value === '0') {
                formik.setFieldValue(`${type}AutoAnticipation`, '');
              }
            }}
          />
        </Field>
        <Field name={`${type}VehicleMaxPrice`} label={t('rule.specificRent.maxPrice')}>
          <CurrencyInput darkPlaceholder placeHolder={t('rule.restriction.withoutRestriction')} />
        </Field>
      </Body>
    </Container>
  );
};

export default AutoRestriction;
